import React, { ReactNode } from 'react';

type ListItemProps = {
  children: ReactNode;
  tagName?: string;
  className?: string;
};

export const ListItem = ({ children, tagName = 'li', className }: ListItemProps) => {
  const Tag = tagName as any;
  const isNative = tagName === 'li' || tagName === 'dt' || tagName === 'dd';

  return (
    <Tag
      className={className}
      role={!isNative ? 'listitem' : undefined}
    >
      {children}
    </Tag>
  );
};
